import React from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, TextField, Typography, Box, Divider 
} from '@mui/material';

const ReportsSection = ({ formData, handleReportChange }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 600 }}>Reports Comparison</Typography>
      <Divider sx={{ mb: 3 }} />
      <TableContainer component={Paper} elevation={1} sx={{ borderRadius: '8px', overflow: 'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Criteria</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Recovery / OT</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Ward</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(formData.reports).map(([key, value]) => (
              <TableRow key={key} hover>
                <TableCell>{key}</TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    value={value.recovery || ""}
                    onChange={(e) => handleReportChange(key, "recovery", e.target.value)}
                    InputProps={{ disableUnderline: true, sx: { fontSize: '0.9rem' } }}
                    sx={{ borderBottom: '1px solid #e0e0e0' }}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    value={value.ward || ""}
                    onChange={(e) => handleReportChange(key, "ward", e.target.value)}
                    InputProps={{ disableUnderline: true, sx: { fontSize: '0.9rem' } }}
                    sx={{ borderBottom: '1px solid #e0e0e0' }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReportsSection;
